import Entity from "../../../class/abstract/Entity";
import InstallationEnabling from "../InstallationEnablings/InstallationEnabling";
import moment from "moment/moment";

class License extends Entity {
    skytill_id = null;
    name = "";
    number = "";
    type = "";
    main = 0;
    version = "";
    status = 0;
    hardware = "";
    ascending_synced_at = null;
    install = null;
    has_contract = null;

    constructor(datas = {}) {
        super(datas);

        this.setAttributes(datas);
    }

    setAttributes(datas) {
        let keys = Object.keys(this);
        let key = "";

        for(let i in keys) {
            key = keys[i];

            if (datas[key] !== undefined) {
                // except keys
                let exceptKeys = ['install'];

                if (!exceptKeys.includes(key))
                    Reflect.set(this, key, datas[key]);
            }
        }

        if (this.ascending_synced_at !== null)
            this.ascending_synced_at = moment.utc(this.ascending_synced_at).toDate();

        if (datas.install !== undefined && datas.install !== null)
            this.install = new InstallationEnabling(datas.install);
    }

	getHardwareInfos() {
		let datas = {
			"name": "",
			"brand": "",
			"model": "",
			"systemType": "",
			"batteryStatus": "",
			"batteryEstimatedChargeRemaining": "",
			"batteryEstimatedRunTime": "",
			"diskSize": "",
			"diskStatus": "",
			"memorySize": "",
			"operatingSystem": "",
			"processor": "",
			"timezone": "",
			"upTime": "",
			"interface": "",
			"gateway": "",
			"ip": "",
		};

		if (this.hardware !== null && this.hardware.length > 0) {
			let hardwareDecode = JSON.parse(this.hardware);
			//console.log("Hardware decode", hardwareDecode);

			if (hardwareDecode !== null) {
				datas["name"] = this.extractName(hardwareDecode);
				datas["brand"] = this.extractBrand(hardwareDecode);
				datas["model"] = this.extractModel(hardwareDecode);
				datas["systemType"] = this.extractSystemType(hardwareDecode);
				datas["batteryStatus"] = this.extractBatteryStatus(hardwareDecode);
				datas["batteryEstimatedChargeRemaining"] = this.extractBatteryEstimatedChargeRemaining(hardwareDecode);
				datas["batteryEstimatedRunTime"] = this.extractBatteryEstimatedRunTime(hardwareDecode);
				datas["diskSize"] = this.extractDiskSize(hardwareDecode);
				datas["diskStatus"] = this.extractDiskStatus(hardwareDecode);
				datas["memorySize"] = this.extractMemorySize(hardwareDecode);
				datas["operatingSystem"] = this.extractOperatingSystem(hardwareDecode);
				datas["processor"] = this.extractProcessor(hardwareDecode);
				datas["timezone"] = this.extractTimezone(hardwareDecode);
				datas["upTime"] = this.extractUpTime(hardwareDecode);
				datas["interface"] = this.extractInterface(hardwareDecode);
				datas["gateway"] = this.extractGateway(hardwareDecode);
				datas["ip"] = this.extractIp(hardwareDecode);
			}
		}

		return datas;
	}

	extractName(hardware) {
		let info = "-";

		if (hardware.computerSystem !== undefined && hardware.computerSystem !== null && hardware.computerSystem.Name !== null)
			info = hardware.computerSystem.Name;

		return info;
	}
	extractBrand(hardware) {
		let info = "-";

		if (hardware.computerSystemProduct !== undefined && hardware.computerSystemProduct !== null && hardware.computerSystemProduct.Vendor !== null)
			info = hardware.computerSystemProduct.Vendor;

		return info;
	}
	extractModel(hardware) {
		let info = "-";

		if (hardware.computerSystemProduct !== undefined && hardware.computerSystemProduct !== null && hardware.computerSystemProduct.Version !== null)
			info = hardware.computerSystemProduct.Version;

		return info;
	}
	extractSystemType(hardware) {
		let info = "-";

		if (hardware.operatingSystem !== undefined && hardware.operatingSystem !== null && hardware.operatingSystem.OSArchitecture !== null)
			info = hardware.operatingSystem.OSArchitecture;

		return info;
	}
	extractBatteryStatus(hardware) {
		let info = "-";

		if (hardware.battery !== undefined && hardware.battery !== null && hardware.battery.Status !== undefined && hardware.battery.Status !== null)
			info = hardware.battery.Status;

		return info;
	}
	extractBatteryEstimatedChargeRemaining(hardware) {
		let info = "-";

		if (hardware.battery !== undefined && hardware.battery !== null && hardware.battery.EstimatedChargeRemaining !== undefined && hardware.battery.EstimatedChargeRemaining !== null)
			info = hardware.battery.EstimatedChargeRemaining + " %";

		return info;
	}
	extractBatteryEstimatedRunTime(hardware) {
		let info = "-";

		if (hardware.battery !== undefined && hardware.battery !== null && hardware.battery.EstimatedRunTime !== undefined && hardware.battery.EstimatedRunTime !== null) {
			let runtime = parseInt(hardware.battery.EstimatedRunTime);
			info = runtime > 3000 ? "-" : runtime + " min";
		}

		return info;
	}
	extractDiskSize(hardware) {
		let info = "-";

		if (hardware.diskDrive !== undefined && hardware.diskDrive !== null && hardware.diskDrive.Size !== null)
			info = this.convertSize(hardware.diskDrive.Size);

		return info;
	}
	extractDiskStatus(hardware) {
		let info = "-";

		if (hardware.diskDrive !== undefined && hardware.diskDrive !== null && hardware.diskDrive.Status !== null)
			info = hardware.diskDrive.Status;

		return info;
	}
	extractMemorySize(hardware) {
		let info = "-";

		if (hardware.computerSystem !== undefined && hardware.computerSystem !== null && hardware.computerSystem.Size !== null)
			info = this.convertSize(hardware.computerSystem.TotalPhysicalMemory);

		return info;
	}
	extractOperatingSystem(hardware) {
		let info = "-";

		if (hardware.operatingSystem !== undefined && hardware.operatingSystem !== null && hardware.operatingSystem.Caption !== null)
			info = hardware.operatingSystem.Caption;

		return info;
	}
	extractProcessor(hardware) {
		let info = "-";

		if (hardware.processor !== undefined && hardware.processor !== null && hardware.processor.Name !== null)
			info = hardware.processor.Name.trim();

		return info;
	}
	extractTimezone(hardware) {
		let info = "-";

		if (hardware.timezone !== undefined && hardware.timezone !== null && hardware.timezone.StandardName !== null)
			info = hardware.timezone.StandardName.trim();

		return info;
	}
	extractUpTime(hardware) {
		let info = "-";

		if (hardware.upTime !== undefined && hardware.upTime !== null)
			info = hardware.upTime.trim();

		return info;
	}
	extractInterface(hardware) {
		let info = "-";

		if (hardware.network !== undefined && hardware.network !== null && hardware.network.interface !== null)
			info = hardware.network.interface.trim();

		return info;
	}
	extractGateway(hardware) {
		let info = "-";

		if (hardware.network !== undefined && hardware.network !== null && hardware.network.gateway !== null)
			info = hardware.network.gateway.trim();

		return info;
	}
	extractIp(hardware) {
		let info = "-";

		if (hardware.network !== undefined && hardware.network !== null && hardware.network.ip !== null)
			info = hardware.network.ip.trim();

		return info;
	}
	convertSize(aSize){
		aSize = Math.abs(parseInt(aSize, 10));
		let def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];

		for(let i= 0; i < def.length; i++) {
			if (aSize < def[i][0])
				return Math.ceil((aSize/def[i-1][0]).toFixed(2)) + ' ' + def[i-1][1];
		}
	}
}

export default License;
